<div class="m-0-auto width-70">
    <pos-edit-wrapper heading="<img src='images/admin/inventory-prep.png' height='22px'> Inventory Prep Recording"
        (close)="cancel()" [isPopup]="false">
        <form #prepForm="ngForm" class="prep-screen">
            <div class="col-12 pos-page-body border-top pt-pix-15 prep-body">
                <div class="col-xl-7 col-lg-9 col-md-10 col-12 p-0 pb-pix-10">

                    <!-- ===== Step 1: What are you making? ===== -->
                    <pos-row class="g-0">
                        <pos-column xs="12" class="p-0">
                            <pos-form-field label="What are you making?"
                                [validationMessages]="{required: 'Please select a product.'}" inputStyle="col-300">
                                <ng-select posInput id="prepProduct" [items]="prepProducts" bindLabel="Name"
                                    bindValue="Id" placeholder="Select product" [(ngModel)]="selectedProductId"
                                    name="prepProduct" (change)="onProductChange()">
                                </ng-select>
                            </pos-form-field>
                        </pos-column>
                    </pos-row>

                    @if (isRecipeLoaded) {
                        <!-- ===== Standard yield: How many are you making? ===== -->
                        @if (!isVariable) {
                            <pos-form-field class="d-block mt-pix-15" label="How many are you making?"
                                inputStyle="col-12 row mx-0"
                                [validationMessages]="{required: 'Please enter product qty.', min: 'Please enter a value greater than zero.', max: 'The entered value is outside the allowed limit.'}">
                                <input posInput class="form-control col-120 ps-0" id="qty" type="number" name="qty"
                                    [(ngModel)]="qty" min="0.01" posDecimal [required]="true" max="999999"
                                    [bypassSubmittedCheck]="isFormSubmitted" #qtyModel="ngModel"
                                    (ngModelChange)="updateUnitName()" />
                                @if (unitName) {
                                    <label class="col-auto edit-form__section__label ps-pix-10 text-nowrap">{{ unitName }}</label>
                                }
                            </pos-form-field>
                        }

                        <!-- ===== Ingredients grid ===== -->
                        <div class="col-12 p-0 mt-pix-15">
                            @if (isVariable) {
                                <label class="edit-form__section__label d-block mb-pix-5">What did you use?</label>
                            }
                            <ng-table [columns]="ingredientColumns" [data]="recipeList" [paginator]="false"
                                [search]="false">
                            </ng-table>
                        </div>

                        <!-- ===== Variable yield: expected + total made ===== -->
                        @if (isVariable) {
                            @if (prepareQty) {
                                <div class="prep-yield mt-pix-15">
                                    Expected <span class="bold">{{ prepareQty | tark_number }} {{ variableUnit }}</span>
                                    to be made, based on recipe.
                                </div>
                            }
                            <pos-form-field class="d-block mt-pix-20" label="Total" inputStyle="col-12 row mx-0"
                                [validationMessages]="{required: 'Please enter quantity.', range: 'Please enter a value greater than zero.'}">
                                <input posInput class="form-control col-120 ps-0" type="number" name="madeQty"
                                    [(ngModel)]="madeQty" min="0" posDecimal [required]="true" [range]="[0.01, 999999]"
                                    [bypassSubmittedCheck]="isFormSubmitted" #madeModel="ngModel" />
                                <label class="col-auto edit-form__section__label ps-pix-10 text-nowrap">{{ variableUnit }} made</label>
                            </pos-form-field>
                        }

                        <!-- Shortage warning (standard yield only) -->
                        @if (anyShort && !isVariable) {
                            <div class="alert condensed inherit-position alert-warning mt-pix-15">
                                <pos-icon [icon]="icons.exclamationTriangle" class="pe-pix-5"></pos-icon>
                                <span>Not enough available qty for this batch.</span>
                            </div>
                        }

                        <!-- Recipe notes -->
                        @if (recipeInformation) {
                            <div class="prep-recipe mt-pix-25">
                                <span class="prep-recipe__heading">Recipe</span>
                                <div class="prep-recipe__body">{{ recipeInformation }}</div>
                            </div>
                        }
                    }
                </div>
            </div>

            <div class="prep-footer">
                <div class="col-12 pos-page-body border-top page-footer">
                    <button class="btn btn-lg bg-theme-separator pos-button" type="button"
                        [disabled]="!hasSelection" (click)="printRecipe()">
                        <pos-icon [icon]="icons.inventorylogprint" class="pe-pix-5"></pos-icon>Print Recipe
                    </button>
                    <span class="float-end">
                        <button class="btn btn-lg btn-primary white pos-button me-pix-5" type="button"
                            [disabled]="!isRecipeLoaded" (click)="recordPrep()">
                            <pos-icon [icon]="icons.inventorylogupdate" class="pe-pix-5"></pos-icon>{{ recordButtonLabel }}
                        </button>
                        <button class="btn btn-lg btn-secondary btn-cancel pos-button" type="button"
                            (click)="hasSelection ? resetRecipe() : cancel()">{{ hasSelection ? "Cancel" : "Close" }}</button>
                    </span>
                </div>
            </div>

            <!-- ===== Column templates ===== -->
            <ng-template let-data="rowData" #ingredientTemplate>
                <b>{{ data.ProductName }}</b>
                @if (data.Instructions) {
                    <div class="grey">{{ data.Instructions }}</div>
                }
            </ng-template>

            <ng-template let-data="rowData" #neededTemplate>
                <span class="text-right d-block">{{ getNeeded(data) | tark_number }}</span>
            </ng-template>

            <ng-template let-data="rowData" let-i="rowIndex" #usedTemplate>
                <span [ngClass]="{ 'has-error': isFormSubmitted && (usedModel.invalid || data.UsedPrepQty < 0) }">
                    <input class="form-control text-right" type="number" min="0" [name]="'used_' + i"
                        [(ngModel)]="data.UsedPrepQty" (input)="calculatePrepQty()" required #usedModel="ngModel" />
                    @if (isFormSubmitted && usedModel.errors?.required) {
                        <label class="control-label">Please enter quantity.</label>
                    } @else if (isFormSubmitted && data.UsedPrepQty < 0) {
                        <label class="control-label">Quantity should be greater than 0.</label>
                    }
                </span>
            </ng-template>

            <ng-template let-data="rowData" #onHandTemplate>
                <span class="text-right d-block" [ngClass]="{ 'red': isVariable ? isShortVar(data) : isShort(data) }">
                    @if (isVariable ? isShortVar(data) : isShort(data)) {
                    <pos-icon class="red pe-pix-5" [icon]="icons.exclamationTriangle" tooltipPosition="top"
                        tooltipStyleClass="custom-tooltip"
                        pTooltip="Only {{ data.CalculatedQty | tark_number }} {{ data.UnitName }} are available in inventory">
                    </pos-icon>
                    }
                    {{ getAvailableQty(data) | tark_number }}
                </span>
            </ng-template>
        </form>
    </pos-edit-wrapper>
</div>
